import React from "react";
import { FiArrowUpRight, FiChevronDown, FiChevronUp } from "react-icons/fi";
import Section from "./Section";

const projects = [
    {
        title: "LakiRemit",
        description:
            "Cross-border remittance product built end-to-end with mobile app, backend API, and transaction-critical workflows.",
        stack: "Mobile app | Backend | FinTech",
        proof: "Live on Google Play",
        link: "https://play.google.com/store/apps/details?id=com.laki_remit_app.laki_remit_app&hl=en",
    },
    {
        title: "GurshaPlus",
        description:
            "Creator monetization platform founded and built end-to-end, live for creators.",
        stack: "Founder-led | Monetization | Live product",
        proof: "Live",
        link: "https://gurshaplus.com",
    },
    {
        title: "YeneCard",
        description:
            "Production virtual card and online transaction app for real users.",
        stack: "FinTech | Payments | Mobile",
        proof: "Live on Google Play",
        link: "https://play.google.com/store/apps/details?id=com.yenecard.yenecard&hl=en",
    },
    {
        title: "BessaPay",
        description:
            "Payment gateway for African markets with QR checkout, multi-currency, and recurring billing.",
        stack: "Payment gateway | Backend | Billing",
        proof: "Live",
        link: "https://bessapay.net/",
    },
    {
        title: "Goby Homes",
        description:
            "Collaborative transaction management platform for secure communication and document workflows.",
        stack: "Real estate | SaaS | Mobile",
        proof: "Live on Google Play",
        link: "https://play.google.com/store/apps/details?id=com.gobyhomes.app&hl=en",
    },
    {
        title: "Postagic",
        description:
            "Mobile product for sending physical postcards and letters from uploaded images.",
        stack: "Consumer app | Mobile",
        proof: "Live on Google Play",
        link: "https://play.google.com/store/apps/details?id=com.postagic.app&hl=en",
    },
    {
        title: "GymLive",
        description:
            "Social platform for gym communities with workout sharing and subscription-oriented product flows.",
        stack: "Social | Subscriptions | Mobile",
        proof: "Live on Google Play",
        link: "https://play.google.com/store/apps/details?id=app.gymlive.mobile.gymlive.prod&pcampaignid=web_share",
    },
    {
        title: "Metahu Delivery",
        description:
            "Food delivery customer app for ordering, browsing, and local delivery workflows.",
        stack: "Delivery | Marketplace | Mobile",
        proof: "Live on Google Play",
        link: "https://play.google.com/store/apps/details?id=metahuCustomer.app&pcampaignid=web_share",
    },
    {
        title: "Dirgebya Shopping",
        description:
            "Mobile shopping app for browsing and ordering from local merchants.",
        stack: "Shopping | Marketplace | Mobile",
        proof: "Live on Google Play",
        link: "https://play.google.com/store/apps/details?id=com.dir_gebeya.customer",
    },
];

function ProjectRow({ project, index }) {
    const content = (
        <div className="group grid gap-5 border-t border-black/15 py-6 sm:grid-cols-[3rem_1fr_auto] sm:items-start">
            <div className="font-mono text-xs font-bold text-black/35">
                {String(index + 1).padStart(2, "0")}
            </div>
            <div>
                <div className="flex flex-wrap items-center gap-3">
                    <h3 className="text-xl font-extrabold text-black">{project.title}</h3>
                    <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-black/45">
                        {project.proof}
                    </span>
                </div>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-black/60">
                    {project.description}
                </p>
                <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.18em] text-black/40">
                    {project.stack}
                </p>
            </div>
            <div className="sm:pt-1">
                {project.link ? (
                    <span className="inline-flex items-center gap-2 font-mono text-xs font-bold uppercase tracking-[0.16em] text-black transition-transform group-hover:translate-x-1">
                        Open <FiArrowUpRight aria-hidden />
                    </span>
                ) : (
                    <span className="font-mono text-xs font-bold uppercase tracking-[0.16em] text-black/35">
                        Private
                    </span>
                )}
            </div>
        </div>
    );

    if (!project.link) {
        return <article>{content}</article>;
    }

    return (
        <a href={project.link} target="_blank" rel="noreferrer" className="block">
            {content}
        </a>
    );
}

export default function Projects() {
    const [showAll, setShowAll] = React.useState(false);
    const visibleProjects = showAll ? projects : projects.slice(0, 5);

    return (
        <Section id="projects" subtitle="Selected work" title="Proof of shipped work">
            <div className="border-b border-black/15">
                {visibleProjects.map((project, index) => (
                    <ProjectRow key={project.title} project={project} index={index} />
                ))}
            </div>

            <button
                type="button"
                onClick={() => setShowAll((value) => !value)}
                className="mt-8 inline-flex items-center gap-2 border-2 border-black px-5 py-3 font-mono text-xs font-bold uppercase tracking-[0.18em] text-black transition-colors hover:bg-black hover:text-white"
            >
                {showAll ? "Show less" : "View all"}
                {showAll ? <FiChevronUp aria-hidden /> : <FiChevronDown aria-hidden />}
            </button>
        </Section>
    );
}
